import React from 'react';
import './Header.css';

interface HeaderProps {
  user: any;
  signOut: ((data?: any) => void) | undefined;
}

const Header: React.FC<HeaderProps> = ({ user, signOut }) => {
  const handleLogout = () => {
    if (!signOut) {
      console.error('signOut function is not available');
      return;
    }

    // Confirmación simple con confirm nativo del navegador
    const confirmed = window.confirm('¿Estás seguro de que quieres cerrar sesión?');
    if (confirmed) {
      try {
        signOut();
        // console.log('Sesión cerrada correctamente');
      } catch (error) {
        // console.error('Error al cerrar sesión:', error);
      }
    }
  };

  return (
    <header id="top-header">
      <div className="header-content">
        <div className="header-left">
          <div className="logo">
            <img src="/assets/voxel3d-logo-cubo.png" alt="Voxel3D Logo" className="logo-icon" />
            <span className="logo-text">BIM Catastro</span>
          </div>
        </div>
        <div className="header-right">
          <div className="user-info">
            <svg className="user-icon" viewBox="0 0 24 24">
              <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
            </svg>
            <span className="user-name">
              {user ? (
                user.signInDetails?.loginId || 
                user.attributes?.email || 
                user.email || 
                user.username
              ) : 'Usuario'}
            </span>
          </div>
          <button 
            id="logoutBtn"
            onClick={handleLogout}
            className="logout-btn" 
            title="Cerrar sesión"
            disabled={!signOut}
          >
            <svg className="logout-icon" viewBox="0 0 24 24">
              <path d="M14.08,15.59L10.67,12.19L14.08,8.79L12.67,7.38L7.29,12.77L12.68,18.16L14.08,16.75M19,3A2,2 0 0,1 21,5V9.67L19,7.67V5H5V19H19V16.33L21,14.33V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19Z"/>
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
